import { useMutation } from '@tanstack/react-query';
import { HcpActivationApi } from '../../../apis/HcpActivationApi/HcpActivationApi.ts';

export function useVerifyHcpActivationCode() {
    return useMutation<void, Error, { token: string; code: string }>({
        mutationFn: ({ token, code }) => HcpActivationApi.verifyCode(token, code),
    });
}
